import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIcon } from "../functions/icons";
import { TileType } from "../constants";
import { faExternalLink, } from "@fortawesome/sharp-solid-svg-icons";
import { HelpText } from "../help-shared/help-container";
import { Icon, IconType } from "../../eone-ui/icons/icons";
import "./tile.css";

//TODO: RENAME
function GettingStartedTile({ Tile, OnClick, Dark }) {

    const tileClass = Dark ? "pd-documentation-tile-small-dark" : "pd-documentation-tile-small";
    const icon = Tile.IconType !== IconType.AppFont ? getIcon(Tile.Icon) : Tile.Icon;

    return (
        <div className={tileClass} onClick={OnClick}>
            <div className="pd-documentation-tile-small-icon">
                <Icon Type={Tile.IconType} Icon={icon} />
            </div>
            <div className="pd-documentation-tile-small-body">
                <div className="pd-documentation-tile-small-body-title pd-documentation-body-1-reg pd-documentation-text-regular">{Tile.Name}</div>
                <div className={"pd-documentation-tile-small-body-text pd-documentation-body-2-reg pd-documentation-text-700"}>{Tile.Description}</div>
            </div>
        </div>
    );
}

function LinkTile({ Tile, OnClick, Theme }) {
    const getDescription = () => {
        if (!Tile.Description) return null;
        return <HelpText Text={Tile.Description} Theme={Theme} />
    };

    const getIcon = () => {
        if (!Tile.External) return null;
        return <FontAwesomeIcon icon={faExternalLink} />
    };

    if (Tile.Type === TileType.Subtitle) {
        return <h4>{Tile.Name}</h4>;
    }

    return (
        <div className={`eone-help-link-tile-container-${Theme}`}>
            <div className={`eone-help-link-tile-link-container-${Theme}`}>
                {getIcon()}
                <div className="pd-link-primary" onClick={() => OnClick(Tile)}>{Tile.Name}</div>
            </div>
            {getDescription()}
        </div>
    );
}

function LinkTiles(props) {
    const getRowGap = () => {
        return props.Theme === "web" ? 16 : 12;
    };

    return (
        <Tiles
            Theme={props.Theme}
            Visible={props.Visible}
            ColumnGap={0}
            RowGap={getRowGap()}
            ColumnNumber={1}
            Tiles={props.Tiles}
            TilesContainersClass="pd-documentation-link-tiles-container"
            Tile={(tile) => <LinkTile Theme={props.Theme} Tile={tile} OnClick={props.OnClick} />} />
    );
}

function TileSpacer(props) {

    const getHeight = () => {
        const gap = props.RowGap * 2;
        if (props.Theme === "web") return 32 - gap;
        return 24 - gap;
    };

    return <div style={{ height: getHeight() }} className="pd-documentation-tiles-spacer" />;
}

function Tiles(props) {
    const getTilesContainerClass = () => {
        return props.TilesContainersClass ? props.TilesContainersClass : "pd-documentation-tiles-container";
    };

    const getTilesContainerStyle = () => {
        const style = {
            gridTemplateColumns: `repeat(${props.ColumnNumber ?? 3}, minmax(0, 1fr))`
        };

        if (props.ColumnGap) {
            style.columnGap = `${props.ColumnGap}px`;
        }
        if (props.RowGap) {
            style.rowGap = `${props.RowGap}px`;
        }

        return style;
    };


    const getTile = (tile, key) => {
        return (
            <div key={key} className="pd-documentation-tile-container">
                {props.Tile(tile)}
            </div>
        );
    };

    const getPinnedTiles = (tiles) => {
        if (tiles.length === 0) return null;

        return (<>
            {tiles.map((tile, i) => getTile(tile, `pinned-${i}`))}
            <TileSpacer Theme={props.Theme} RowGap={props.RowGap ?? 0} />
        </>);
    };

    const getRegularTiles = (tiles) => {
        if (tiles.length === 0) return null;

        const columnNumber = props.ColumnNumber ?? 3;
        const rowGap = props.RowGap ?? 0;
        const subtitleStyle = { gridColumn: `span ${columnNumber}`, margin: `${64 - rowGap}px 0px ${32 - rowGap}px` };

        return tiles.map((tile, i) => {
            if (tile.Type === TileType.Subtitle) {
                return (
                    <h4 style={subtitleStyle} key={i} className="pd-documentation-tile-subtitle">
                        {tile.Name}
                    </h4>
                );
            }

            return getTile(tile, i);
        });
    };

    const getTiles = () => {
        return (<>
            {getPinnedTiles(props.Tiles.filter(tile => tile.PinToTop))}
            {getRegularTiles(props.Tiles.filter(tile => !tile.PinToTop))}
        </>);
    };

    if (props.Visible === false || !props.Tiles || props.Tiles.length === 0) {
        return;
    }

    return (
        <div className={getTilesContainerClass()} style={getTilesContainerStyle()}>
            {getTiles()}
        </div>
    );
}

export { GettingStartedTile, Tiles, LinkTiles, LinkTile };